import { Pipe, PipeTransform } from '@angular/core';
import { NavHeaderButtonTypeEnum } from '@app/features/my-cvs/data-structures/my-cvs.interface';

@Pipe({
  name: 'routeCheck',
})
export class RouteCheckPipe implements PipeTransform {
  transform(path: string, navHeaderButtonCode: string): boolean {
    return path.includes(NavHeaderButtonTypeEnum[navHeaderButtonCode.toUpperCase()]);
  }
}
